import React, { useImperativeHandle, useRef } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { MdSettings, MdDelete } from 'react-icons/md';
import styled from 'styled-components';
import ItemTypes from './ItemTypes';
import palette from '../../lib/styles/palette';
const style = {
  display: 'flex',
  cursor: 'move',
  transition: '0.3s',
};
const SelectFC = styled.div`
  min-width: 100%;
  height: fit-content;
  position: sticky;
  & + & {
    margin-top: 20px;
  }
`;
const FCPhotoBlock = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
const FCPhoto = styled.img`
  width: 100px;
  height: auto;
  @media screen and (max-width: 1600px) {
    width: 80px;
  }
`;

const FCInfo = styled.div`
  padding: 3px 20px 0 10px;
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

const FCTitleBlock = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  width: 300px;
`;

const FCTitle = styled.div`
  font-size: 16px;
  color: ${palette.webGray[10]};
  margin-bottom: 4px;
  font-weight: bold;
`;

const NumberBlock = styled.div`
  background: ${palette.webGray[15]};
  width: auto;
  color: #000;
  border-radius: 1rem;
  font-size: .75rem;
  width: 60px;
  padding: 5px 0;
  text-align: center;
`;
const SelectFCItemCenter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 400px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  
  & div {
    width: 100%;
    text-align: left;
  }
`;
const FCIdBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 340px;
`;
const Name = styled.div`
  font-size: 16px;
  color: ${palette.webGray[10]};
  margin-bottom: 4px;
  font-weight: bold;
`;

const FCActionsBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 6px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.danger ? '#ffebee' : '#e3f2fd'};
  }

  svg {
    font-size: 20px;
    color: ${props => props.danger ? '#d32f2f' : '#1976d2'};
  }
`;
const Card = React.forwardRef(
  (
    {
      text,
      id,
      isDragging,
      index,
      connectDragSource,
      connectDropTarget,
      viewMoreBtn,
      isProgram,
      moreBtn,
      onRemoveProgram,
      onClickMoreBtn,
      item,
      selectFC,
      fcList,
      url,
      onSetSelectFC,
      setGoalModal,
      setHistoryModal,
      onRemoveSelectFCItem,
      initEditMode,
      onOpenHistoryModal,
    },
    ref,
  ) => {
    const bleNumberRenderer = () => {
      const arr = [];
      let temp = [];
      if (!fcList) return null;
      const machineNumbers = fcList.find((el) => el.fcindex === id);
      if (!!!machineNumbers) return <></>;
      const machineNumber = machineNumbers.numbers;
      if (machineNumber.length === 0) return <></>;
      for (let i = 0; i < machineNumber.length; i++) {
        if (machineNumber[i + 1] === machineNumber[i] + 1) {
          temp.push(machineNumber[i]);
        } else {
          temp.push(machineNumber[i]);
          arr.push(temp);
          temp = [];
        }
      }
      return (
        <NumberBlock>
          {arr.map((innerArr, idx) => (
            <div key={idx}>
              {innerArr.length === 1
                ? `${innerArr[0]}번${idx === arr.length - 1 ? `` : `,`}`
                : `${innerArr[0]}번 ~ ${innerArr[innerArr.length - 1]}번${
                    idx === arr.length - 1 ? `` : `,`
                  }`}
            </div>
          ))}
        </NumberBlock>
      );
    };
    const elementRef = useRef(null);
    connectDragSource(elementRef);
    connectDropTarget(elementRef);
    const opacity = isDragging ? 0 : 1;
    const background =
      selectFC && selectFC.fcindex === item.fcindex
        ? palette.skyBlueAlpha2
        : 'none';
    useImperativeHandle(ref, () => ({
      getNode: () => elementRef.current,
    }));

    if(id == 0) return null;

    return (
      <SelectFC ref={elementRef} style={{ ...style, opacity, background }}>
        <FCPhotoBlock>
          <FCPhoto
            //src={require(`../../resources/images/fcImage/fcimage_${id}.png`)}
            src={`https://kr.object.ncloudstorage.com/qnoss/Res/image/fcimage_${id}.png`}
            alt={`${item.fcname}`}
            onError={() => console.error('faild exercise image load.')}
            onClick={() => onClickMoreBtn(1, item)}
          />
        </FCPhotoBlock>
        <FCInfo>
            <FCIdBlock>
              <Name>{item.fcname}</Name>
              {item.numbers && item.numbers.length > 0 &&
              <NumberBlock>
                {item.numbers[0]}번
              </NumberBlock>}
            </FCIdBlock>
          { item.fctype == 1 || item.fctype == 2 ?
            <SelectFCItemCenter style={{textAlign: 'center'}}>
              <div><b style={{marginRight: '10px'}}>[목표]</b>
                {item.goal.time != 0 && `${item.goal.time / 60}분`}
                {item.goal.distance != 0 && `${item.goal.distance / 1000}km`}
                {item.goal.calorie != 0 && `${item.goal.calorie / 10}kcal`}
              </div>
            </SelectFCItemCenter>
          :
            item.fctype == 3 ?
            <SelectFCItemCenter>
              { item.goal.set.map((goal, idx) => (
                  <div key={idx}><b style={{marginRight: '10px'}}>[{idx + 1} Set]</b> {goal.weight > 0 ? `${goal.weight}kg X ` : ""}{goal.count}회</div>
              ))}
            </SelectFCItemCenter>
            :
            item.fctype == 4 && item.freeweightType == 0 ?
            <SelectFCItemCenter>
              { item.goal.set.map((goal, idx) => (
                  <div key={idx}><b style={{marginRight: '10px'}}>[{idx + 1} Set]</b> {goal.weight > 0 ? `${goal.weight}kg X ` : ""}{goal.count}회</div>
              ))}
            </SelectFCItemCenter>
            :
            item.fctype == 4 && item.freeweightType == 1 ?
            <SelectFCItemCenter>
              { item.goal.set.map((goal, idx) => (
                  <div key={idx}><b style={{marginRight: '10px'}}>[{idx + 1} Set]</b> {goal.count}회</div>
              ))}
            </SelectFCItemCenter>
            :
            item.fctype == 4 && item.freeweightType == 2 ?
            <SelectFCItemCenter>
              { item.goal.set.map((goal, idx) => {
                const minutes = Math.floor(goal.count / 60);
                const seconds = goal.count % 60;
                let timeDisplay = '';
                if (minutes > 0) {
                  timeDisplay += `${minutes}분`;
                }
                if (seconds > 0) {
                  if (minutes > 0) timeDisplay += ' ';
                  timeDisplay += `${seconds}초`;
                }
                if (timeDisplay === '') {
                  timeDisplay = '0초';
                }
                return (
                  <div key={idx}><b style={{marginRight: '10px'}}>[{idx + 1} Set]</b> {timeDisplay}</div>
                );
              })}
            </SelectFCItemCenter>
            :null
          }
          <FCActionsBlock>
            {item.fctype != 6 && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  // fcList에서 freeweightType 정보를 가져와서 item과 병합
                  const fcInfo = fcList?.find(fc => fc.fcindex === item.fcindex);
                  const itemWithFreeweightType = {
                    ...item,
                    freeweightType: fcInfo?.freeweightType ?? item.freeweightType ?? 0
                  };
                  console.log('Card item:', item);
                  console.log('Card fcInfo:', fcInfo);
                  console.log('Card itemWithFreeweightType:', itemWithFreeweightType);
                  // 무게가 설정되어 있는지 확인
                  const hasWeight = item.goal?.set?.some(s => s.weight > 0);
                  initEditMode(hasWeight);
                  onSetSelectFC(itemWithFreeweightType);
                  setGoalModal(true);
                }}
                title="운동 목표 설정"
              >
                <MdSettings />
              </IconButton>
            )}
            <IconButton
              danger
              onClick={(e) => {
                e.stopPropagation();
                onRemoveSelectFCItem(item);
              }}
              title="삭제"
            >
              <MdDelete />
            </IconButton>
          </FCActionsBlock>
        </FCInfo>
      </SelectFC>
    );
  },
);
export default DropTarget(
  ItemTypes.CARD,
  {
    hover(props, monitor, component) {
      if (!component) {
        return null;
      }
      // node = HTML Div element from imperative API
      const node = component.getNode();
      if (!node) {
        return null;
      }
      const dragIndex = monitor.getItem().index;
      const hoverIndex = props.index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = node.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      props.moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      monitor.getItem().index = hoverIndex;
    },
  },
  (connect) => ({
    connectDropTarget: connect.dropTarget(),
  }),
)(
  DragSource(
    ItemTypes.CARD,
    {
      beginDrag: (props) => ({
        id: props.id,
        index: props.index,
      }),
    },
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging(),
    }),
  )(Card),
);
